// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';

Vue.config.productionTip = false;

window.VosCtx = {
  acceptCommand(inCommand) {
    console.log(`in command! ${inCommand}`);

    // The Vos object is  injected from the flutter shell
    // ESLint doesn't know how to deal with this so...
    // eslint-disable-next-line
    if (Vos && inCommand && inCommand !== "unknown") {
      // eslint-disable-next-line
      Vos.postMessage(`web got command: ${inCommand}`);
    }
  },
};

Vue.prototype.$VosCtx = window.VosCtx;


Vue.prototype.$UserMediaStreamSource = null;


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js